import React from 'react';
import './DashboardOverview.css';

// A simple helper for pluralization
const pluralize = (count, singular, plural) => (count === 1 ? singular : plural);

const DashboardOverview = ({
  products = [],
  categories = [],
  reviews = [],
  events = [],
  chats = [],
  users = [],
  handleNavClick,
}) => {

  const overviewSections = [
    {
      key: 'products',
      title: 'Gestion des Produits',
      stat: `${products.length} ${pluralize(products.length, 'produit', 'produits')}`,
      icon: '📦',
      description: 'Ajoutez, modifiez ou supprimez des produits.',
    },
    {
      key: 'categories',
      title: 'Gestion des Catégories',
      stat: `${categories.length} ${pluralize(categories.length, 'catégorie', 'catégories')}`,
      icon: '🏷️',
      description: 'Organisez vos produits en différentes catégories.',
    },
    {
      key: 'attributes',
      title: 'Gestion des Attributs',
      stat: 'Couleurs, matières...',
      icon: '🎨',
      description: 'Gérez les couleurs, matières et types de perles.',
    },
    {
      key: 'agenda',
      title: 'Gestion de l\'Agenda',
      stat: `${events.length} ${pluralize(events.length, 'événement', 'événements')}`,
      icon: '🗓️',
      description: 'Planifiez et gérez les événements à venir.',
    },
    {
      key: 'reviews',
      title: 'Gestion des Avis',
      stat: `${reviews.length} ${pluralize(reviews.length, 'avis', 'avis')}`,
      icon: '⭐',
      description: 'Modérez les avis laissés par les clients.',
    },
    {
      key: 'messages',
      title: 'Messagerie',
      stat: `${chats.length} ${pluralize(chats.length, 'conversation', 'conversations')}`,
      icon: '💬',
      description: 'Consultez et répondez aux messages des utilisateurs.',
    },
    {
      key: 'users',
      title: 'Gestion des Utilisateurs',
      stat: `${users.length} ${pluralize(users.length, 'utilisateur', 'utilisateurs')}`,
      icon: '👥',
      description: 'Gérez les comptes et les rôles des utilisateurs.',
    },
    {
      key: 'my-account',
      title: 'Mon Compte',
      stat: 'Profil & Sécurité',
      icon: '👤',
      description: 'Mettez à jour vos informations personnelles.',
    },
  ];

  return (
    <div className="dashboard-overview">
      <div className="overview-header">
        <h2>Tableau de Bord Principal</h2>
        <p>Accédez rapidement à toutes les sections de gestion de votre site.</p>
      </div>
      <div className="overview-grid">
        {overviewSections.map((section) => (
          <div key={section.key} className="overview-card">
            <div className="card-icon">{section.icon}</div>
            <div className="card-content">
              <h4>{section.title}</h4>
              <p className="card-stat">{section.stat}</p>
              <p className="card-description">{section.description}</p>
            </div>
            <button
              className="card-button"
              onClick={() => handleNavClick(section.key)}
            >
              Gérer
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardOverview;
